import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { ActionButton } from "../../styles/communityCommon";
import { QuestionCss } from "../../styles/theme/question";
import { APPROVE_ANS, GET_ANSWER_BY_QUESTION } from "../../api";

const Question = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const [questionId, setQuestionId] = useState(props.question.id);
  const [answers, setAnswers] = useState([]);

  useEffect(() => {
    GET_ANSWER_BY_QUESTION(questionId)
      .then((res) => {
        console.log("GETTING ANSWER RES: ", res);

        setAnswers(res.data);
      })
      .catch((er) => {
        console.log("Error while getting answer:", er);
      });
  }, [questionId]);

  const approveHandler = (AnswerId) => {
    APPROVE_ANS(AnswerId, true)
      .then((res) => {
        console.log("Approve Ans API: ", res);
      })
      .catch((er) => {
        console.log("Error while approving:", er);
      });
  };

  return (
    <>
      <QuestionCss />
      <div className="parent-container">
        <motion.div
          transition={{ layout: { duration: 1, type: "spring" } }}
          layout
          onClick={() => setIsOpen(!isOpen)}
          className="question-card"
        >
          <motion.h2 layout="position">{props.question.content}</motion.h2>
          {isOpen && (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 1 }}
              className="question-content"
            >
              {answers.map((e) => {
                return (
                  <div className="answers-container">
                    <div>
                      <b>Answer: </b> {e.answer}
                    </div>
                    <div>
                        {e.approved && <div className="success-msg">Approved</div>}
                      {!e.approved && <ActionButton onClick={() => {approveHandler(e.id)}}>Approve</ActionButton>}
                    </div>
                  </div>
                );
              })}
            </motion.div>
          )}
        </motion.div>
      </div>
    </>
  );
};

export default Question;
